(function () {
    'use strict';

    angular
        .module('app')
        .config(config);

    config.$inject = ['$stateProvider', '$locationProvider', '$urlRouterProvider', '$compileProvider', '$httpProvider', '$resourceProvider', 'i18nProvider',];

    function config($stateProvider, $locationProvider, $urlRouterProvider, $compileProvider, $httpProvider, $resourceProvider, i18nProvider) {
        // Sets URL mode to html5
        $locationProvider.html5Mode({
            enabled: true,
            requireBase: false,
        });

        // Appends trailing slash if it's missing
        $urlRouterProvider.rule(function ($injector, $location) {
            var path = $location.path(),
                hasTrailingSlash = path[path.length - 1] === '/';

            if (!hasTrailingSlash) {
                return path + '/';
            }
        });

        // URL states

        /*
         * $stateProvider.state({
         *   name: 'search',
         *   url: '/search/{term}/',
         *   component: 'search',
         *});
         */

        $stateProvider
            .state({
                name: 'groups',
                url: '/groups/',
                component: 'groups',
            })
            .state({
                name: 'groups.list',
                url: 'list/?:searchObject',
                component: 'groupsList',
                reloadOnSearch: false,
            })
            .state({
                name: 'groups.add',
                url: 'add/?:schoolId',
                component: 'groupsAdd',
                params: {
                    schoolId: null,
                },
            })
            .state({
                name: 'groups.edit',
                url: 'edit/{id}/',
                component: 'groupsEdit',
            })
            .state({
                name: 'users',
                url: '/users/',
                component: 'users',
            })
            .state({
                name: 'users.list',
                url: 'list/?:searchObject',
                component: 'usersList',
                reloadOnSearch: false,
            })
            .state({
                name: 'users.add',
                url: 'add/?:schoolId?:groupId?:userType',
                component: 'usersAdd',
                params: {
                    schoolId: null,
                    groupId: null,
                    userType: null,
                }
            })
            .state({
                name: 'users.edit',
                url: 'edit/{id}/',
                component: 'usersEdit',
            })
            .state({
                name: 'schools',
                url: '/schools/',
                component: 'schools',
            })
            .state({
                name: 'schools.list',
                url: 'list/?:searchObject',
                component: 'schoolsList',
                reloadOnSearch: false,
            })
            .state({
                name: 'schools.add',
                url: 'add/',
                component: 'schoolsAdd',
            })
            .state({
                name: 'schools.edit',
                url: 'edit/{id}/',
                component: 'schoolsEdit',
            })
            .state({
                name: 'games',
                url: '/games/',
                component: 'games',
            })
            .state({
                name: 'games.list',
                url: 'list/?:searchObject',
                component: 'gamesList',
                reloadOnSearch: false,
            })
            .state({
                name: 'games.add',
                url: 'add/',
                component: 'gamesAdd',
            })
            .state({
                name: 'games.edit',
                url: 'edit/{tag}/',
                component: 'gamesEdit',
            })
            .state({
                name: 'segments',
                url: '/segments/',
                component: 'segments',
            })
            .state({
                name: 'segments.list',
                url: 'list/?:searchObject',
                component: 'segmentsList',
                reloadOnSearch: false,
            })
            .state({
                name: 'segments.edit',
                url: 'edit/{tag}/',
                component: 'segmentsEdit',
            })
            .state({
                name: 'subjects',
                url: '/subjects/',
                component: 'subjects',
            })
            .state({
                name: 'subjects.add',
                url: 'add/',
                component: 'subjectsAdd',
            })
            .state({
                name: 'subjects.list',
                url: 'list/?:searchObject',
                component: 'subjectsList',
                reloadOnSearch: false,
            })
            .state({
                name: 'subjects.edit',
                url: 'edit/{id}/',
                component: 'subjectsEdit',
            })
            .state({
                name: 'gameBundles',
                url: '/game-bundles/',
                component: 'gameBundles',
            })
            .state({
                name: 'gameBundles.list',
                url: 'list/?:searchObject',
                component: 'gameBundlesList',
                reloadOnSearch: false,
            })
            .state({
                name: 'b2bPartners',
                url: '/b2b-partners/',
                component: 'b2bPartners',
            })
            .state({
                name: 'b2bPartners.list',
                url: 'list/?:searchObject',
                component: 'b2bPartnersList',
                reloadOnSearch: false,
            })
            .state({
                name: 'b2bPartners.add',
                url: 'add/',
                component: 'b2bPartnersAdd',
            })
            .state({
                name: 'b2bPartners.edit',
                url: 'edit/{id}/',
                component: 'b2bPartnersEdit',
            })
            .state({
                name: 'contracts',
                url: '/contracts/',
                component: 'contracts',
            })
            .state({
                name: 'contracts.list',
                url: 'list/?:searchObject',
                component: 'contractsList',
                reloadOnSearch: false,
            })
            .state({
                name: 'contracts.add',
                url: 'add/?:schoolId?:schoolName',
                component: 'contractsAdd',
                params: {
                    schoolId: null,
                    schoolName: null,
                }
            })
            .state({
                name: 'contracts.edit',
                url: 'edit/{id}/',
                component: 'contractsEdit',
            })
            .state({
                name: 'campaigns',
                url: '/campaigns/',
                component: 'campaigns',
            })
            .state({
                name: 'campaigns.list',
                url: 'list/?:searchObject',
                component: 'campaignsList',
                reloadOnSearch: false,
            })
            .state({
                name: 'campaigns.add',
                url: 'add/?:type',
                component: 'campaignsAdd',
                params: {
                    type: null,
                }
            })
            .state({
                name: 'campaigns.edit',
                url: 'edit/{id}/?:searchObject',
                component: 'campaignsEdit',
                reloadOnSearch: false,
            })
            .state({
                name: 'leads',
                url: '/leads/',
                component: 'leads',
            })
            .state({
                name: 'leads.list',
                url: 'list/?:searchObject',
                component: 'leadsList',
                reloadOnSearch: false,
            })
            .state({
                name: 'leads.add',
                url: 'add/?:type',
                component: 'leadsAdd',
                params: {
                    type: null,
                }
            })
            .state({
                name: 'leads.edit',
                url: 'edit/{id}/?:searchObject',
                component: 'leadsEdit',
                reloadOnSearch: false,
            })
            .state({
                name: 'badges',
                url: '/badges/',
                component: 'badges',
            })
            .state({
                name: 'badges.list',
                url: 'list/?:searchObject',
                component: 'badgesList',
                reloadOnSearch: false,
            })
            .state({
                name: 'badges.add',
                url: 'add/?:type',
                component: 'badgesAdd',
                params: {
                    type: null,
                }
            })
            .state({
                name: 'badges.edit',
                url: 'edit/{id}/',
                component: 'badgesEdit',
            })
            .state({
                name: 'dashboard',
                url: '/dashboard/',
                component: 'dashboard',
            })
            .state({
                name: 'serverHealth',
                url: '/server-health/',
                component: 'serverHealth',
            })
            .state({
                name: 'statistics',
                url: '/statistics/',
                component: 'statistics',
            })
            .state({
                name: 'log',
                url: '/log/?:searchObject',
                component: 'log',
                reloadOnSearch: false,
            })
            .state({
                name: 'recycleBin',
                url: '/recycle-bin/?:searchObject',
                component: 'recycleBin',
                reloadOnSearch: false,
            })
            .state({
                name: 'cacs',
                url: '/cacs/?:year?:month',
                component: 'cacs',
                params: {
                    month: null,
                    year: null,
                },
                // reloadOnSearch: false,
            })
            .state({
                name: 'winbackCampaigns',
                url: '/winback-campaigns/',
                component: 'winbackCampaigns',
            })
            .state({
                name: 'winbackCampaigns.list',
                url: 'list/?:searchObject',
                component: 'winbackCampaignsList',
                reloadOnSearch: false,
            })
            .state({
                name: 'winbackCampaigns.add',
                url: 'add/',
                component: 'winbackCampaignsAdd',
            })
            .state({
                name: 'winbackCampaigns.edit',
                url: 'edit/{id}/',
                component: 'winbackCampaignsEdit',
            })
            .state({
                name: 'winbackOffers',
                url: '/winback-offers/',
                component: 'winbackOffers',
            })
            .state({
                name: 'winbackOffers.list',
                url: 'list/?:searchObject',
                component: 'winbackOffersList',
                reloadOnSearch: false,
            })
            .state({
                name: 'winbackOffers.add',
                url: 'add/',
                component: 'winbackOffersAdd',
            })
            .state({
                name: 'winbackOffers.edit',
                url: 'edit/{id}/',
                component: 'winbackOffersEdit',
            })
            .state({
                name: 'winbackStateOffers',
                url: '/winback-state-offers/',
                component: 'winbackStateOffers',
            })
            .state({
                name: 'winbackStateOffers.list',
                url: 'list/?:searchObject',
                component: 'winbackStateOffersList',
                reloadOnSearch: false,
            })
            .state({
                name: 'winbackStateOffers.add',
                url: 'add/',
                component: 'winbackStateOffersAdd',
            })
            .state({
                name: 'winbackStateOffers.edit',
                url: 'edit/{id}/',
                component: 'winbackStateOffersEdit',
            })
            .state({
                name: 'userExport',
                url: '/user-export/',
                component: 'userExport',
            })
            .state({
                name: 'userExport.list',
                url: 'list/?:searchObject',
                component: 'userExportList',
                reloadOnSearch: false,
            })
            .state({
                name: 'login',
                url: '/',
                component: 'login',
            });

        // Redirect to start if no state is matched.
        $urlRouterProvider
            .otherwise('/');

        // Debug.
        $compileProvider.debugInfoEnabled(Boolean(window.config.debug));

        // HTTP Auth Interceptor.
        $httpProvider.interceptors.push('HttpAuthInterceptorService');

        // API Error Logger
        $httpProvider.interceptors.push('HttpErrorInterceptorService');

        // API Response Interceptor
        // enable this when the API delivers date strings in UTC.
        //$httpProvider.interceptors.push('HttpApiInterceptor');

        // Don't strip trailing slashes on resource URL's.
        $resourceProvider.defaults.stripTrailingSlashes = false;

        // eslint-disable-next-line no-undef
        if (Chart) {
            // eslint-disable-next-line no-undef
            Chart.defaults.global.colors = ['#38c172', '#ffed4a', '#e3342f', '#3490dc', '#f66d9b', '#9561e2', '#4185ab'];
        }

        // eslint-disable-next-line no-undef
        moment.locale('sv');

        i18nProvider.setLanguages(['en', 'sv']);
        i18nProvider.setDefaultLanguage(function () {
            var lang = 'en',
                queryLangMatch = window.location.search.match(/lang(uage)?=(en|sv)/i);

            if (queryLangMatch && queryLangMatch[2]) {
                lang = queryLangMatch[2];
            } else if (window.location.href.indexOf('.se') !== -1) {
                lang = 'sv';
            } else if (window.location.href.indexOf('.com') !== -1) {
                lang = 'en';
            } else if (window.navigator.language) {
                lang = window.navigator.language.substring(0, 2);
            }

            if (['en', 'sv',].indexOf(lang) === -1 && config.get('debug')) {
                return 'en';
            }

            return lang.toLowerCase();
        });
        i18nProvider.debugMode(window.config.debug);
        i18nProvider.setPathToTranslations(function (language) {
            return 'i18n/' + language + '.json';
        });

    }
})();